/**
 * GraphQL queries for content images
 * @module content-detail/content-detail-images/queries
 */
import { gql } from '@apollo/client'

/**
 * Get image content relationships for a content detail
 */
export const GET_CONTENT_IMAGES = gql`
  query GetContentImages($contentId: Int!, $contentType: String!, $language: [String!]!) {
    contentList(
      where: { contentId: { eq: $contentId }, contentType: { eq: $contentType } }
      language: $language
      limit: 1
    ) {
      content {
        id
        contentId
        contentType
        language
        primaryLanguage
        imageContentRelationships(language: $language) {
          id
          type
          image {
            id
            url
            originalFileName
          }
        }
      }
    }
  }
`
